<div class="h-100">
  <finxone-web-frontend-international-currency-country
    class="h-100"
    [showCurrencyFlags]="showCurrencyFlags"
    [currencyCodes]="currenciesCodes"
    [countryList]="countryList"
    [customStyle]="contentStyle"
    [widgetConfig]="widgetConfig"
    [currentInactiveStyle]="currentStyle"
    [currentActiveStyle]="currentActiveStyle"
    [continueButtonContent]="continueButtonContent"
    [continueButtonStyle]="continueButtonStyle"
    [globalStylingClass]="globalStylingClass"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [isNewAddBeneficiaryIntlExist]="isNewAddBeneficiaryIntlExist"
  >
  </finxone-web-frontend-international-currency-country>
</div>
